import { ALL_NOTIFICATION_TOGGLES } from "../constants";
import type {
  ChatNotificationLevel,
  NotificationPreferencePayload,
  NotificationToggleKey,
} from "../types";

export const buildNotificationPreferences = (
  toggles: NotificationToggleKey[],
): NotificationPreferencePayload =>
  ALL_NOTIFICATION_TOGGLES.reduce<NotificationPreferencePayload>((acc, key) => {
    acc[key] = toggles.includes(key) ? "all" : "never";
    return acc;
  }, {} as NotificationPreferencePayload);

export const mapChatNotificationLevelToToggles = (
  level: ChatNotificationLevel,
): NotificationToggleKey[] => {
  if (level === "all") {
    return [
      "default_mobile_notification_setting",
      "default_mention_mobile_notification_setting",
      "default_mention_in_app_notification_setting",
    ];
  }
  if (level === "mentions") {
    return [
      "default_mention_mobile_notification_setting",
      "default_mention_in_app_notification_setting",
    ];
  }
  return [];
};
